export default __webpack_public_path__ + "static/media/slider-3.fa7bfc82.jpg";